<template>
  <div  class="content-y" id="positionAnonPage" >
     <div  class="content-main">
    <div id='positionAnon'  style="display:flex;flex:1;flex-direction: column;">
      <Layout id="AppViewport">
        <Content class="app-body" >
          <div class="app-ploter-main" v-loading="this.loading" element-loading-text="加载中">
            <div class="app-ploter-main-body">
              <div ref="ploterWrap" class="app-editor-ploter-wrap positionlist">
                <div class="app-editor-ploter-navigation" >
                  <div class="ploter-navigation-list">
                    <el-button v-for="data in zgtableData" style="width: 4.375rem;"  :key="data.uuid" @click="getStage(data.uuid,$event)"
                    size="small" type="primary"
                      v-bind:class="{'selected': data.uuid==zguuid}">{{data.zgmc}}</el-button>
                  </div>
                  <div class="ploter-navigation-tools">
                    <el-button icon="el-icon-view" style="width: 6.125rem " size="small" type="success"
                      @click="isViewAll = true">{{viewTitle}}</el-button>
                  </div>
                </div>
              </div>
              <!-- 画布容器 -->
              <div class="app-ploter-main-canvas" ref="plotStage"></div>
              <div class="app-ploter-main-mask"></div>
            </div>
          </div>
          <ComponentsBusinessShape @evt_stage_element_remove="doShapeDelete" />
        </Content>
        <appPloterWidgetMove class="fx"></appPloterWidgetMove>
        <AppPloterWidgetScale v-if="stage" :stage="stage" @evtStageCfgChanged="onStageCfgChanged" @evtStageScaleChanged="onStageScaleChanged"
          @evtStageScaleReset="onStageScaleReset" class="plusmin"></AppPloterWidgetScale>
      </Layout>
    </div>
    </div>
    <el-dialog :title="viewTitle" :visible.sync="isViewAll" width="30%" >
      <el-image :src="vsrc" :preview-src-list="[vsrc]" style="width: 100%; height: 400px;" >
       </el-image>
    </el-dialog>
  </div>
</template>
<script>
  import {
    mapGetters
  } from "vuex";
  import drawLib from "@/views/exhibition/ploter/draw";
  import plotundo from "@/plugins/plotundo";
  import {
    exitPlotTool,
    deleteShape
    // ,pasteShape
  } from "@/views/exhibition/ploter/draw/utils";
  import {
    prepareStageData,
    prepareStageElements,
    getShapeOnStage,
    clearShapeStyle
  } from "@/views/exhibition/ploter/draw/stage";
  import {
    Base64
  } from "js-base64";
  import {
    deepClone,getSrc
  } from "@/common/ploter/utils";
  // 共通组件
  import componentsBusinessShape from "@/components/ploter/businessShape";
  // 标绘组件
  import appPloterBBarMessage from "@/views/exhibition/ploter/bbar/Message";
  import appPloterBBarCoordinate from "@/views/exhibition/ploter/bbar/Coordinate";
  import appPloterBBarStageAttr from "@/views/exhibition/ploter/bbar/StageAttr";
  // widget
  import appPloterWidgetScale from "@/views/exhibition/ploter/widget/Scale";
  import appPloterWidgetMove from "@/views/exhibition/ploter/widget/Move";

  export default {
    name: "AppPloterMain",
    components: {
      ComponentsBusinessShape: componentsBusinessShape,
      AppPloterBBarMessage: appPloterBBarMessage,
      AppPloterBBarCoordinate: appPloterBBarCoordinate,
      AppPloterBBarStageAttr: appPloterBBarStageAttr,
      AppPloterWidgetScale: appPloterWidgetScale,
      AppPloterWidgetMove: appPloterWidgetMove
    },
    data() {
      return {
        currentUser: this.CONSTANT.currentUser,
        vsrc:'',
        viewTitle:"展馆预览",
        isViewAll:false,
        isBoothStart: false, //选展位是否开始
        //读取图片base路径
        baseUrl: window.config.baseUrl,
        //上个路由页面传过来的数据
        query: this.$route.query,
        //当前展位数据
        currentBusinessData: {},
        currentUuid: "",
        zguuid: "",
        zgtableData: null,
        lastEl: null,
        lastEvent: null,
        //显示加载中样
        loading: false,
        stage: null,
        currentPlotTool: null,
        currentPlotActiveItem: null,
        currentPasteItem: null,
        footer: {
          show: false
        },
        coordinateSystem: {
          system: "像素",
          x: 0,
          y: 0
        },
        ploterCfg: {
          readOnly: true,
          businessShape: {
            enable: true,
            requestLoop: 0 // 0为不轮询
          }
        },
        timer: ''
      };
    },
    computed: {
      ...mapGetters({
        wrapStageData: "wrapStageData",
        ploterConfig: "ploterConfig",
        stageElements: "stageElements",
        stageSize: "stageSize",
        componentsBusinessShapeData: "componentsBusinessShapeData"
      })
    },
    watch: {
      zguuid(val,old){
        this.vsrc = getSrc(val)
      }
    },
    created() {
      drawLib.initLocalSetting();
      if (window.wrapHandshake._events.evtBusinessShapeSelected) {
        window.wrapHandshake._events.evtBusinessShapeSelected = null
      }
    },
    mounted() {
      this.isStart();
      this.initZg();
      this.initLang()
      this.timer = setInterval(() => {
        this.refresh();
      }, window.config.booth.anonRefreshTime);
    },
    beforeDestroy() {
      clearInterval(this.timer);
    },
    methods: {
      //选择展位是否开始
      isStart() {
        let me = this;
        me.$axios.post("/zwjbxx/isStart").then(
          function(res) {
            if (res.data.isBoothStart) {
              me.isBoothStart = res.data.isBoothStart
            }
          }.bind(this),
          function(error) {
            console.log(error);
          }
        );
      },
      //lxy 0225 开始
      //初始化当前页面
      initZg() {
        const me = this;
        //获取展馆列表
        me.$axios.post("/zgjbxx/doSearchDataListByVO",{}).then(
          function(res) {
            this.zgtableData = res.data.result;
            if (me.query.uuid) {
              me.zguuid=me.query.uuid
              this.getStage(this.query.uuid);
              return
            }
            if (this.zgtableData.length > 0) {
              me.zguuid=this.zgtableData[0].uuid
              this.getStage(this.zgtableData[0].uuid);
            }
          }.bind(this),
          function(error) {
            console.log(error);
          }
        );
      },

      refresh: function() {
        //定时只更新数据
        this.initBusinessData(this.zguuid);
      },

      getStage(uuid, event) {
        const me = this;
        this.loading = true
        window.moftPloter = {};
        var params = {
          uuid: uuid
        };
        this.zguuid = uuid;
        me.$axios.post("/zgjbxx/doSearchHbMKListByVO", params).then(
          function(res) {
            if (res.data.result.zgjbxxVO) {
              var zgjbxx = res.data.result.zgjbxxVO
              var currentShapesData = res.data.result.zwmoJsonDatas;
              var currentAreaStage = zgjbxx.zgzwhbStr;
              var zgtpdz = zgjbxx.zgtpdz
              var path = me.baseUrl + 'upload/' + zgtpdz
              var currentAreaStageObj = JSON.parse(currentAreaStage);
              //处理图片
              var http = require('http');
              http.get(path, function(res) {
                var chunks = [];
                var size = 0;
                res.on('data', function(chunk) {
                  chunks.push(chunk);
                  size += chunk.length; //累加缓冲数据的长度
                });
                res.on('end', function(err) {
                  var data = Buffer.concat(chunks, size);
                  var base64Img = data.toString('base64');
                  currentAreaStageObj.children["0"].children[1].attrs._shapeCfg.style.mainShape.src = `data:image/png;base64,${base64Img}`

                  me.zgmc = zgjbxx.zgmc
                  currentAreaStage = JSON.stringify(currentAreaStageObj)
                  var stageRecord = {
                    stageData: currentAreaStage,
                    shapesData: currentShapesData,
                    uuid: params.uuid
                  };
                  me.$store.commit("updateStageData", stageRecord);
                  me.initPloter(currentAreaStage || null, currentShapesData || null);
                  plotundo.init();
                  me.initBusinessData(params.uuid);
                  //放大缩小系数调为1.0
                  window.wrapHandshake.$emit("evt_stage_scale_changed", {
                    scaleLevel: 1
                  });
                  me.doStageScaleReset();

                });
              });
            }
          }.bind(this),
          function(error) {
            console.log(error);
          }
        );
      },
      initLang() {
        if (this.query.lan == 'ENG') {
           this.viewTitle = 'view'
        }
      },
      initBusinessData(zgid) {
        this.isStart()
        const me = this;
        let lan = me.query.lan;
        
        if(!lan){
          if(this.currentUser && this.currentUser.usertype=='ENG'){
            lan = 'ENG'
          }else{
            lan = 'CHN'
          }
          
        }
        var params1 = {
          zgid: zgid,
          lan: lan
        };
        this.loading = false
        me.$axios.post("/zwjbxx/doSearchListByVOBooth", params1).then(
          function(res) {
            var businessData = [];
          //  console.log(me.isBoothStart);
            for (var i = 0; i < res.data.length; i++) {
              businessData.push(this.back2plot(res.data[i],lan, me.isBoothStart));
            }
            // 外到里call 里到外emit
            me.$store.commit("updateBusinessShapeData", businessData);
          }.bind(this),
          function(error) {
            console.log(error);
          }
        );
      },
      initPloter(stageData, shapesData) {
        const me = this;
        me.$store.commit("updatePloterCongig", this.ploterCfg);
        if (!stageData) {
          if (me.stage) {
            const warn = confirm(
              "现在执行新建操作将放弃对当前画布做出的修改，\n点击确认按钮前请确认您的标绘成果已经保存。"
            );
            if (warn === true) {
              me.stage.destroy();
            }
          }
          const createCfg = me.ploterConfig.createCfg;
          if (createCfg) {
            if (createCfg.type === "img") {
              stageData = drawLib.createEmptyStageData({
                width: createCfg.width,
                height: createCfg.height,
                backgroundImage: createCfg.from
              });
              me.initStage(stageData, ".app-ploter-main-canvas");
            }
          } else {
            stageData = drawLib.createEmptyStageData();
            me.initStage(stageData, ".app-ploter-main-canvas");
          }
        } else {
          let stageDataObj = JSON.parse(stageData);
          stageDataObj.children[1].children = shapesData || [];
          me.initStage(stageDataObj, ".app-ploter-main-canvas");
        }
        if (!this.ploterConfig.readOnly) {
          me.footer.show = true;
        }
      },
      initStage(stageData, wrap) {
        const me = this;
        if (window.ploterStage) {
          window.ploterStage.destroy();
        }

        function onWindowReady() {
          if (window.innerWidth > 0) {
            const data = prepareStageData(stageData);
            me.$store.commit("updateStageSize", {
              width: data.attrs.width,
              height: data.attrs.height+35
            });
            // 画布比窗口大，设置为窗口大小
            if (data.attrs.width >= window.innerWidth) {
              data.attrs.width = window.innerWidth;
              data.attrs.height = window.innerHeight;
            }
            const stage = Konva.Node.create(data, wrap);
            me.stage = stage;
            window.ploterStage = stage;
            //  stage 存到store
            me.$store.commit("updatePloterStage", stage);
            me.setStageLayout();
            drawLib.reloadShapes(stage);
          } else {
            setTimeout(() => {
              onWindowReady();
            }, 100);
          }
        }
        onWindowReady();
      },
      doShapeDelete(shape) {
        const stage = this.stage;
        const shapeWrap = shape.findAncestor(".shapeWrap");
        deleteShape(shape);
        stage.fire("evt_stage_element_changed", {
          changeType: "delete",
          element: shapeWrap
        });
        this.currentPlotActiveItem = null;
      },
      doExitPlotTool() {
        const me = this;
        const stage = me.stage;
        stage.fire("evt-stop");
        exitPlotTool(stage);
        me.currentPlotTool = null;
        me.currentPlotActiveItem = null;
      },
      onStageCfgChanged(cfg) {
        drawLib.applyStageCfg(this.stage, cfg);
      },
      onStageScaleChanged(value) {
        this.doStageScale(value);
      },
      onStageScaleReset() {
        this.doStageScaleReset();
      },
      onSelectShape(shapeUuid) {
        const me = this;
        const shape = getShapeOnStage(shapeUuid);

        if (shape) {
          me.doSelectShape(shape.findOne(".mainShape"));
        }
      },
      initPlotTool() {
        if (!this.currentPlotTool) return;
        const toolCfg = { ...deepClone(this.currentPlotTool)
        };
        const stage = this.stage;
        drawLib.initPlotTool(toolCfg, stage);
      },
      doSelectShape(target) {
        const me = this;
        const targetWrap = target.findAncestor(".shapeWrap");
        const targetMain = targetWrap.findOne(".mainShape");
        targetMain.fire("evt-active", targetMain);
        me.currentPlotActiveItem = targetMain;
      },
      doStageScale(value) {
        const stage = this.stage;
        //let ploterMainBody = document.querySelector(".app-ploter-main-body");
        let ploterMainBody = this.$el.querySelector(".content-main");
        // const ploterWrap = document.querySelector('.konvajs-content')
        const ploterWrapSize = {
          width: Math.round(this.stageSize.width * value),
          height: Math.round(this.stageSize.height * value)
        };
        ploterMainBody.style.width = ploterWrapSize.width + "px";
        ploterMainBody.style.height = ploterWrapSize.height + "px";
        stage.setAttrs({
          width: ploterWrapSize.width,
          height: ploterWrapSize.height
        })
        stage.scale({
          x: value,
          y: value
        });
        stage.draw();
        // stage.fire("evt_stage_scale_changed", {
        //   scaleLevel: value
        // });
        // lxy 修改20200302
        window.wrapHandshake.$emit("evt_stage_scale_changed", {
          scaleLevel: value
        });
        //this.setStageLayout()
      },
      doStageScaleReset() {
        const stage = this.stage;
        //let ploterMainBody = document.querySelector(".app-ploter-main-body");
        let ploterMainBody = this.$el.querySelector(".content-main");
        // const ploterWrap = document.querySelector('.konvajs-content')

        ploterMainBody.style.width = this.stageSize.width + "px";
        ploterMainBody.style.height = this.stageSize.height + "px";
        stage.setAttrs({
          width: this.stageSize.width,
          height: this.stageSize.height
        })
        stage.scale({
          x: 1,
          y: 1
        });
        stage.draw();
        stage.fire("evt_stage_scale_changed", {
          scaleLevel: 1
        });
        //this.setStageLayout()
      },
      setStageLayout() {
        const me = this;
        // const plotStageEl = me.$refs.plotStage
        const stage = me.stage;

        let ploterMain = document.querySelector(".app-ploter-main");
        //let ploterMainBody = document.querySelector(".app-ploter-main-body");
        let ploterMainBody = me.$el.querySelector(".content-main");


        ploterMainBody.style.width = me.stageSize.width + "px";
        ploterMainBody.style.height = me.stageSize.height + "px";
        window.ploterScroll = {
          top: ploterMain.scrollTop,
          left: ploterMain.scrollLeft
        };
        ploterMain.addEventListener("scroll", function() {
          let dx = ploterMain.scrollLeft;
          let dy = ploterMain.scrollTop;
          stage.container().style.transform =
            "translate(" + dx + "px, " + dy + "px)";
          stage.x(-dx);
          stage.y(-dy);
          stage.batchDraw();
          window.ploterScroll = {
            top: dy,
            left: dx
          };
        });
        // let wrapWidth = window.innerWidth
        // if (me.currentPlotActiveItem) {
        //     wrapWidth = window.innerWidth - 320
        // }

        // if (wrapWidth > stage.width()) {
        //     plotStageEl.setAttribute('data-layout-center', true)
        // } else {
        //     plotStageEl.removeAttribute('data-layout-center')
        // }
      },
      onWindowResize() {
        const stage = this.stage;
        stage.setWidth(window.innerWidth);
        stage.setHeight(window.innerHeight);
      },
    }
  };
</script>

<style lang="scss">
  @import "~@/assets/app.scss";
  #positionAnonPage {
    //display: flex;
    flex: 1;
    flex-direction: column;
    box-sizing: border-box;
    width: auto;
    height: 100%;
    overflow: auto;
  }
  #positionAnonPage .content-main {
    overflow: hidden;
  }

  #positionAnon{
    .el-button {
      margin-right: 10px;
      width: 3.125rem;
    }
    .el-button+.el-button {
      margin-left: 0px;
      margin-right: 10px;
    }

    .fx {
      margin-top: 60px;
    }

    .plusmin {
      margin-top: 60px;
    }

    .content[data-v-57ee01a8] {
      overflow-y: hidden;
    }

    #menu-toggle-btn {
      right: -26px;
      transform: rotateY(180deg);
    }

    .app-editor {
      width: 960px;
      margin: 16px auto;
    }

    .app-editor-list-item {
      display: flex;
      flex-direction: column;
      float: left;
      width: 300px;
      height: 240px;
      margin: 10px;

      > {
        .ivu-card-extra {
          top: 8px;
          right: 8px;

          .ivu-btn-text {
            padding: 4px 8px;
          }

          .ivu-icon {
            font-size: 16px;
          }
        }

        .ivu-card-body {
          position: relative;
          flex: 1;
          padding: 8px;
          background-color: #fafafa;
        }
      }
    }

    .app-editor-list-item-add {
      text-align: center;

      >.ivu-icon {
        line-height: 140px;
        font-size: 80px;
        font-weight: bold;
      }
    }

    .app-editor-list-item-thumb {
      height: 100%;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: contain;
    }

    .app-editor-ploter-wrap {
      flex-direction: column;
      background-color: #666;
    }

    /* 展位选择右侧按钮样式 */
    .cancelbtn {
      border: 0px;
      height: 30px;
      line-height: 0px;
      background: rgb(243, 26, 55);
      color: #fff;
      margin: 0px 3px 5px 3px;
      // padding-left: 35px;
    }

    .app-ploter-tools-graphs-menu-item {
      height: 30px;
      line-height: 0px;
      background: #0684e5;
      color: #fff;
      margin: 5px 3px 5px 0px;
    }

    .app-editor-ploter-navigation {
      margin-top: 10px;
      position: fixed;
      z-index: 9999;
      display: flex;
      height: 40px;


      width: 100%;
      background-color: #fff;
      > {
        .ploter-navigation-list {
          flex: 1;
          line-height: 36px;
          font-size: 16px;

          //text-indent: 24px;
        }

        .ploter-navigation-tools {
           position: fixed;
           right: 10px;
           flex: 1;
           float: right;
           line-height: 36px;
           font-size: 16px;
           background-color: #fff;
        }

      }
    }

    .app-editor-ploter-iframe {
      display: block !important;
      flex: 1;
      border: none;
    }

    .app-editor-create-model>.file-name {
      margin-left: 16px;
    }

    .app-editor-cropper-model> {
      .ivu-modal-body {
        padding: 0;
      }

      .moft-cropper {
        height: 64vh !important;
      }
    }

    .positionlist {
      // height: 100%;
      overflow: hidden;

      -webkit-transition-duration: 0.3s;
      -moz-transition-duration: 0.3s;
      -o-transition-duration: 0.3s;
      -ms-transition-duration: 0.3s;
    }

    .app-ploter-tools-graphs-menu-item {
      height: 30px;
      line-height: 0px;
      background: #0684e5;
      color: #fff;
      margin: 5px 3px 5px 0px;
    }

    .btn {
      // border: 5px solid #0684e5;
      border-radius: 100px;
      height: 10px;
      line-height: 0px;
      background: #e56606;
      color: #fff;
      margin: 5px 3px 5px 3px;

      // padding-left: 35px;
      &:hover {
        border: 0px;
        height: 10px;
        line-height: 0px;
        background: rgb(199, 89, 5);
        color: #fff;
        margin: 6px 3px 5px 5px;
        // padding-left: 35px;
      }

      &:focus {
        border: 0px;
        height: 30px;
        line-height: 0px;
        background: rgb(165, 74, 4);
        color: #fff;
        margin: 5px 3px 5px 3px;
        // padding-left: 35px;
      }
    }

    .imagez {
      float: left;
      width: 100px;
      height: 100px;
      padding: 5px;
    }

    .box-card {
      float: left;
      width: 130px;
      margin: 5px;
    }

    .box-cardz {
      float: left;
      width: 270px;
      margin: 5px;
    }

    .text {
      font-size: 14px;
    }

    .clearfix {
      font-weight: bold;
      text-align: center;
    }

    .selected {
      background: #666666;
    }

    .app-ploter-main-canvas {
      margin-top: 60px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/exhibition/booth/anon/PositionAnon.vue